import { FC } from "react"
import { AutocompleteElement } from "react-hook-form-mui"
import { QUERY_TYPES } from "../../constants"

interface IProps {
  name?: string
  required?: boolean
  disabled?: boolean
}

const options = QUERY_TYPES.map((t) => ({ id: t.type, label: t.label }))

export const QueryTypeSelect: FC<IProps> = ({
  name = "queryType",
  required,
  disabled,
}) => (
  <AutocompleteElement
    name={name}
    label="Тип запроса"
    required={required}
    matchId
    options={options}
    autocompleteProps={{
      disabled,
      disableClearable: required,
      sx: { minWidth: 220 },
    }}
  />
)
